export { ColorPill } from "./ColorPill";
export type { PillSize } from "./types";
